import { Autocomplete, Box, FormControl, FormLabel, Grid, TextField } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import React from "react";

const Autocompletes = ({top100Films, flatProps}) => {
	return (
		<Box>
			<h3>Standard</h3>
			<Grid container spacing={3}>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Description')}</FormLabel>
						<Autocomplete
							disablePortal
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="standard"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Disabled')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							disabled
							defaultValue={top100Films[1]}
							renderInput={(params) =>
								<TextField {...params} variant="standard"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Read Only')}</FormLabel>
						<Autocomplete
							{...flatProps}
							id="readOnly"
							readOnly
							defaultValue={flatProps.options[13]}
							renderInput={(params) => (
								<TextField {...params} variant="standard"/>
							)}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required>
						<FormLabel>{('Required')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="standard"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required error={true}>
						<FormLabel>{('Error')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="standard"/>}
						/>
						<FormHelperText>
							{'Απαιτείται'}
						</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Placeholder')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="standard" placeholder={"Placeholder"}/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Multiple')}</FormLabel>
						<Autocomplete
							multiple
							id="tags-standard"
							options={top100Films}
							getOptionLabel={(option) => option.label}
							defaultValue={[top100Films[13]]}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="standard"
								/>
							)}
						/>
					</FormControl>
				</Grid>
			</Grid>
			<h3>Outlined</h3>
			<Grid container spacing={3}>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Description')}</FormLabel>
						<Autocomplete
							disablePortal
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="outlined"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Disabled')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							disabled
							defaultValue={top100Films[1]}
							renderInput={(params) =>
								<TextField {...params} variant="outlined"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Read Only')}</FormLabel>
						<Autocomplete
							{...flatProps}
							id="readOnly"
							readOnly
							defaultValue={flatProps.options[13]}
							renderInput={(params) => (
								<TextField {...params} variant="outlined"/>
							)}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required>
						<FormLabel>{('Required')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="outlined"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required error={true}>
						<FormLabel>{('Error')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="outlined"/>}
						/>
						<FormHelperText>
							{'Απαιτείται'}
						</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Placeholder')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="outlined" placeholder={"Placeholder"}/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Multiple')}</FormLabel>
						<Autocomplete
							multiple
							id="tags-standard"
							options={top100Films}
							getOptionLabel={(option) => option.label}
							defaultValue={[top100Films[13]]}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="outlined"
								/>
							)}
						/>
					</FormControl>
				</Grid>
			</Grid>
			<h3>Filled</h3>
			<Grid container spacing={3}>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Description')}</FormLabel>
						<Autocomplete
							disablePortal
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="filled"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Disabled')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							disabled
							defaultValue={top100Films[1]}
							renderInput={(params) =>
								<TextField {...params} variant="filled"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Read Only')}</FormLabel>
						<Autocomplete
							{...flatProps}
							id="readOnly"
							readOnly
							defaultValue={flatProps.options[13]}
							renderInput={(params) => (
								<TextField {...params} variant="filled"/>
							)}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required>
						<FormLabel>{('Required')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="filled"/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}} required error={true}>
						<FormLabel>{('Error')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="filled"/>}
						/>
						<FormHelperText>
							{'Απαιτείται'}
						</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Placeholder')}</FormLabel>
						<Autocomplete
							id="combo-box-demo"
							options={top100Films}
							renderInput={(params) =>
								<TextField {...params} variant="filled" placeholder={"Placeholder"}/>}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={3}>
					<FormControl sx={{width: '100%'}}>
						<FormLabel>{('Multiple')}</FormLabel>
						<Autocomplete
							multiple
							id="tags-standard"
							options={top100Films}
							getOptionLabel={(option) => option.label}
							defaultValue={[top100Films[13]]}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="filled"
								/>
							)}
						/>
					</FormControl>
				</Grid>
			</Grid>
			
			{/*TODO::OTHER AUTOCOMPLETES*/}
			{/*<Stack spacing={1} sx={{width: 300}}>*/}
			{/*<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						
						id="disable-close-on-select"
						disableCloseOnSelect
						renderInput={(params) => (
							<TextField {...params} label="disableCloseOnSelect" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="clear-on-escape"
						clearOnEscape
						renderInput={(params) => (
							<TextField {...params} label="clearOnEscape" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="disable-clearable"
						disableClearable
						renderInput={(params) => (
							<TextField {...params} label="disableClearable" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="include-input-in-list"
						includeInputInList
						renderInput={(params) => (
							<TextField {...params} label="includeInputInList" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...flatProps}
						id="flat-demo"
						renderInput={(params) => (
							<TextField {...params} label="flat" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="controlled-demo"
						value={'mpla'}
						onChange={(event, newValue) => {
							// setValue(newValue);
						}}
						renderInput={(params) => (
							<TextField {...params} label="controlled" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="auto-complete"
						autoComplete
						includeInputInList
						renderInput={(params) => (
							<TextField {...params} label="autoComplete" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="disable-list-wrap"
						disableListWrap
						renderInput={(params) => (
							<TextField {...params} label="disableListWrap" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="open-on-focus"
						openOnFocus
						renderInput={(params) => (
							<TextField {...params} label="openOnFocus" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="auto-highlight"
						autoHighlight
						renderInput={(params) => (
							<TextField {...params} label="autoHighlight" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="auto-select"
						autoSelect
						renderInput={(params) => (
							<TextField {...params} label="autoSelect" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="disabled"
						disabled
						renderInput={(params) => (
							<TextField {...params} label="disabled" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="disable-portal"
						disablePortal
						renderInput={(params) => (
							<TextField {...params} label="disablePortal" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="blur-on-select"
						blurOnSelect
						renderInput={(params) => (
							<TextField {...params} label="blurOnSelect" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="clear-on-blur"
						clearOnBlur
						renderInput={(params) => (
							<TextField {...params} label="clearOnBlur" variant="standard"/>
						)}
					/>
				</Grid>
				<Grid item xs={3}>
					<Autocomplete
						{...defaultProps}
						id="select-on-focus"
						selectOnFocus
						renderInput={(params) => (
							<TextField {...params} label="selectOnFocus" variant="standard"/>
						)}
					/>
				</Grid>
			
			</Grid>*/}
			{/*</Stack>*/}
		</Box>
	)
}

export default Autocompletes;